export const validateEmissionDates = (values, translate) => {
    if (values.isPermanent) {
        return {};
    }

    const errors = {};
    if (!values.startDate) {
        errors.startDate = translate('resources.adsCampaign.validation.startDateRequired');
    }
    if (!values.endDate) {
        errors.endDate = translate('resources.adsCampaign.validation.endDateRequired');
    }
    return errors;
};

export const validateDisplayHours = (values, translate) => {
    if (values.isContinuous) {
        return {};
    }

    const errors = {};
    if (!values.hourFrom) {
        errors.hourFrom = translate('resources.adsCampaign.validation.hourFromRequired');
    }
    if (!values.hourTo) {
        errors.hourTo = translate('resources.adsCampaign.validation.hourToRequired');
    } else if (values.hourFrom && values.hourFrom >= values.hourTo) {
        errors.hourTo = translate('resources.adsCampaign.validation.hourToAfterHourFrom');
    }
    return errors;
};

const hasAdvertisementImage = value => {
    if (!value) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.length > 0;
    }

    return Boolean(value.rawFile || value.src || value instanceof File);
};

export const validateAdvertisementForm = (values, translate, { requireImage = true } = {}) => {
    const errors = {
        ...validateEmissionDates(values, translate),
        ...validateDisplayHours(values, translate),
    };

    if (!values.contractorId) {
        errors.contractorId = translate('common.validation.required');
    }
    if (!values.name?.trim()) {
        errors.name = translate('common.validation.required');
    }
    if (requireImage && !hasAdvertisementImage(values.advertisementImage)) {
        errors.advertisementImage = translate('resources.adsCampaign.validation.imageRequired');
    }
    if (values.contractorId && (!values.deviceGroupIds || values.deviceGroupIds.length === 0)) {
        errors.deviceGroupIds = translate('resources.adsCampaign.validation.deviceGroupsRequired');
    }

    return errors;
};
